<template>
  <div class="custom-selectbox">
    <VueSelect
      v-model="selectedOption"
      :reduce="(option: any) => option.handle"
      :options="options"
      :placeholder="placeholder"
      :class="{ disabled: disabled }"
      :disabled="disabled"
      :filter-by="filter"
      :style="cssVars"
    >
      <template #option="option">
        <slot name="custom_option" :option="option">
          {{ option.label }}
        </slot>
      </template>
      <template #list-footer>
        <slot name="custom_list-footer" />
      </template>
    </VueSelect>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import VueSelect from 'vue-select'

export default defineComponent({
  name: 'CustomSelect',
  components: {
    VueSelect,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    selected: {
      type: [String, Number],
      default: null,
      required: false,
    },
    placeholder: {
      type: String,
      default: '',
      required: false,
    },
    height: {
      type: String,
      default: '200px',
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    filter: {
      type: Function,
      default: (option: any, _: any, search: string) => {
        const temp = search.toLowerCase()
        return option.label.toLowerCase().indexOf(temp) > -1
      },
    },
  },
  emits: ['selected'],
  setup(props, { emit }) {
    const selectedOption = computed({
      get: () => props.selected,
      set: (val) => {
        emit('selected', val)
      },
    })
    const cssVars = {
      '--max-height': props.height,
    }
    return {
      cssVars,
      selectedOption,
    }
  },
})
</script>
